var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2114_39719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9827 5.4068C17.9827 5.90286 17.5806 6.30499 17.0845 6.30499C16.5885 6.30499 16.1863 5.90286 16.1863 5.4068V1.81397H12.5935C12.0974 1.81397 11.6953 1.41184 11.6953 0.915773C11.6953 0.419709 12.0974 0.0175781 12.5935 0.0175781H16.5815C16.9532 0.0175781 17.3096 0.165206 17.5723 0.42798C17.8351 0.690754 17.9827 1.04716 17.9827 1.41878V5.4068Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3048 0.425185C16.6555 0.074419 17.2243 0.0744161 17.575 0.425185C17.9258 0.775954 17.9258 1.34467 17.575 1.69544L9.63489 9.63557C9.28413 9.98633 8.71541 9.98633 8.36464 9.63557C8.01387 9.2848 8.01387 8.71608 8.36464 8.36531L16.3048 0.425185Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0175781 16.1852V1.81397C0.0175804 1.33753 0.206848 0.880627 0.543738 0.543738C0.880627 0.206848 1.33753 0.0175804 1.81397 0.0175781H8.99961C9.49567 0.0175781 9.8978 0.419709 9.8978 0.915773C9.8978 1.41184 9.49567 1.81397 8.99961 1.81397H1.81397V16.1852H16.1852V8.99961C16.1852 8.50354 16.5874 8.10141 17.0834 8.10141C17.5795 8.10141 17.9816 8.50354 17.9816 8.99961V16.1852C17.9816 16.6617 17.7924 17.1186 17.4555 17.4555C17.1186 17.7924 16.6617 17.9816 16.1852 17.9816H1.81397C1.33754 17.9816 0.880627 17.7924 0.543738 17.4555C0.206848 17.1186 0.0175807 16.6617 0.0175781 16.1852Z",
    fill: "#3D3C42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2114_39719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.b3155e48538b9a38933153d768cace2c.svg";
export { ForwardRef as ReactComponent };